<template>
  <div class="body-box marginBox">
    <el-row class="plan" :gutter="20">
      <el-col :span="24">
        <el-tabs v-model="activeName" @tab-click="btnStatus">
          <el-tab-pane label="待确定" name="CONFIRM"></el-tab-pane>
          <el-tab-pane label="已取消" name="CANCEL"></el-tab-pane>
          <el-tab-pane label="已完成" name="END"></el-tab-pane>
          <el-tab-pane label="全部" name="ALL"></el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder='商品的名称/预约人' @change="handleQuery"/>
      </el-col>
      <el-col :span='5'>
        <search-input v-model="queryInfo.orderNo" placeholder='订单号' @change="handleQuery"/>
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 120px)'" :data="orderList" class="button-box">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table :data="scope.row.ogList" class="button-box">
            <el-table-column label="商品名称" prop="goods.name" />
            <el-table-column label="规格" prop="goodsMode.mode" />
            <el-table-column label="价格" prop="price" />
            <el-table-column label="积分" prop="goodsMode.score" />
            <el-table-column label="下单数量" prop="total" />
            <el-table-column label="支付方式" prop="enumPayment">
              <template slot-scope="scope">
                {{scope.row.enumPayment | payment}}
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>

      <el-table-column label="订单编号" prop="orderNum" />
      <el-table-column label="状态" prop="enumStatus">
        <template slot-scope="scope">{{scope.row.enumStatus | orderStatus}}</template>
      </el-table-column>
      <el-table-column label="总数量" prop="num" />
      <el-table-column label="优惠券优惠" prop="cuType">
        <template slot-scope="scope">{{couponPrice(scope.row)}}</template>
      </el-table-column>
      <el-table-column label="总价格" prop="price" />
      <el-table-column label="总积分" prop="integral" />
      <el-table-column label="收货人" prop="addr.contact" />
      <el-table-column label="电话" prop="addr.tel" />
      <el-table-column label="收货地址">
        <template slot-scope="scope">
          <template v-if='scope.row.addr'>
            {{scope.row.addr.provinceCityCountyAddr + '-'}}{{scope.row.addr.addr}}
          </template>
        </template>
      </el-table-column>
      <el-table-column label="下单时间">
        <template slot-scope="scope">
          {{scope.row.createDatetime | formatDate('yyyy-MM-dd hh:mm')}}
        </template>
      </el-table-column>
      <el-table-column label="备注" prop="brief" />
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <!--<div><el-button v-if="queryInfo.status === 'CONFIRM'" @click="decidedOrder(scope.row)">待确定</el-button></div>-->
              <div><el-button @click="getUserInfoByOrder(scope.row)">查看下单用户信息</el-button></div>
              <div><el-button v-if="queryInfo.status === 'END'" @click="editOrder(scope.row)">待积分</el-button></div>
              <div><el-button  @click="openOrder(scope.row)">修改状态</el-button></div>
              <div><modify-cost v-if="scope.row.enumStatus !== 'CANCEL'" :orderCost="scope.row.cost" :orderId="scope.row.orderId"
                                @change="handleQuery"></modify-cost></div>
              <div><delete-order :orderId="scope.row.orderId" orderType="COURT" @change="handleQuery"></delete-order></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref='page' :query-param.sync='queryInfo' @pagination='getOrderList'></pagination></div>

    <!--修改状态对话框-->
    <el-dialog title="确认订单" :visible.sync="dialogVisibleDecidedOrder" width="30%">
      <el-form label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="是否支付">
              <el-input></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="修改状态">
              <el-input></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="发送确认书">
              <el-input></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleDecidedOrder = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleDecidedOrder = false">确 定</el-button>
      </span>
    </el-dialog>

    <!--修改状态-->
    <modify-order @refresh-list="handleQuery" ref="modifyOrder"></modify-order>

    <!--发放积分-->
    <order-integral @refresh-list="handleQuery" ref="orderIntegral"></order-integral>

    <!--获取用户信息-->
    <user-info ref="getUserInfo"></user-info>

  </div>
</template>
<script>
import { getPostOrDeleteData } from '@/utils/code'
import { deleteOrder, selectBackOrderGoodsList } from '@/api/order/order'
import ModifyOrder from '@/components/common/modifyOrder/index'
import OrderIntegral from '@/components/common/orderIntegral/orderIntegral'
import ModifyCost from '@/components/common/modifyCost/modifyCost'
import DeleteOrder from '@/components/common/deleteOrder/deleteOrder'
import UserInfo from '@/components/common/user/userInfo'
import Pagination from '@/components/common/Pagination/index'
import SearchInput from '@/components/common/searchInput/searchInput'
import Template from '@/views/template/template.vue'

export default {
  components: { Template, SearchInput, DeleteOrder, ModifyCost, Pagination, ModifyOrder, OrderIntegral, UserInfo },
  data() {
    return {
      activeName: 'CONFIRM',
      queryInfo: {
        keyword: '',
        status: 'CONFIRM'
      },
      orderList: [],
      dialogVisibleDecidedOrder: false
    }
  },
  created() {
    this.handleQuery()
  },

  watch: {
    queryInfo(newData) {
      this.activeName = newData.status === '' ? 'ALL' : newData.status
    }
  },

  methods: {
    // 计算是优惠积分还是金额
    couponPrice(row) {
      let str = '未使用'
      if (row.useCoupon) {
        if (row.ucType === 'INTEGRAL') {
          str = Math.floor(row.couponPrice/5) + '积分'
        } else {
          str = row.couponPrice + '元'
        }
      }
      return str
    },
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },

    //查询列表
    getOrderList(page, cb) {
      selectBackOrderGoodsList(page).then((r) => {
        this.orderList = cb(r)
      })
    },

    openOrder(row) {
      this.$refs.modifyOrder.editDialog(row, 'GOODS')
    },

    //按钮状态
    btnStatus(val) {
      this.queryInfo.status = val.name === 'ALL' ? '' : val.name
      this.handleQuery()
    },

    //根据ID删除数据
    removeOrderById(id) {
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteOrder(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }).catch(() => {
      })
    },

    //修改
    editOrder(row) {
      this.integralData = JSON.parse(JSON.stringify(row))
      this.$refs.orderIntegral.editDialog(this.integralData)
    },

    //查看下单用户信息
    getUserInfoByOrder(row) {
      this.$refs.getUserInfo.getUserInfo(row.userInfo)
    }

  }
}
</script>

<style lang="less" scoped>

</style>
